var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from "axios";
import { getUserFromLocalStorage } from "./localStorage";
export const getUserProfileDetails = () => __awaiter(void 0, void 0, void 0, function* () {
    const { account_id, access_token } = getUserFromLocalStorage();
    const url = `${process.env.REACT_APP_HELLOAR_API}accounts/${account_id}`;
    try {
        const { data } = yield axios.get(url, {
            headers: { Authorization: `Token ${access_token}` },
        });
        return data;
    }
    catch (error) {
        console.error(error);
        throw new Error("Error while fetching profile details");
    }
});
export const patchUserProfileDetails = (patchData) => __awaiter(void 0, void 0, void 0, function* () {
    const { account_id, access_token } = getUserFromLocalStorage();
    const url = `${process.env.REACT_APP_HELLOAR_API}accounts/${account_id}`;
    try {
        yield axios.patch(url, patchData, {
            headers: { Authorization: `Token ${access_token}` },
        });
    }
    catch (error) {
        console.error(error);
        throw new Error("Failed to save profile details");
    }
});
